var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPadlockWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 10.7822H2.66667C1.74619 10.7822 1 11.5149 1 12.4186V18.1459C1 19.0496 1.74619 19.7822 2.66667 19.7822H14.3333C15.2538 19.7822 16 19.0496 16 18.1459V12.4186C16 11.5149 15.2538 10.7822 14.3333 10.7822Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70898 5.63675C3.70898 4.40701 4.1975 3.22763 5.06706 2.35807C5.93662 1.48851 7.11599 1 8.34574 1C9.57548 1 10.7549 1.48851 11.6244 2.35807C12.494 3.22763 12.9825 4.40701 12.9825 5.63675V10.7825",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPadlockWhite);
export default __webpack_public_path__ + "static/media/icon-padlock-white.7da384cb0841cb368f06e9227b8d9229.svg";
export { ForwardRef as ReactComponent };